"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsUnvalidatedRailgunAddress = exports.validateContractAddress = void 0;
const address_1 = require("@ethersproject/address");
const validateContractAddress = (address) => {
    return (0, address_1.isAddress)(address);
};
exports.validateContractAddress = validateContractAddress;
const getIsUnvalidatedRailgunAddress = (address) => {
    if (address.startsWith('0zk')) {
        return true;
    }
    if (address.startsWith('0x')) {
        return false;
    }
    throw new Error(`Invalid address: ${address}`);
};
exports.getIsUnvalidatedRailgunAddress = getIsUnvalidatedRailgunAddress;
